export const trackHouston = ({message}: {message: string}) => {
  const event = {
    event: 'control',
    action: 'houston',
    label: message,
    value: null,
  };

  return event;
};
